import api from './axios';

const BASE = '/sourcing-orders';

// indexes: null sends arrays as repeated keys (sort=a&sort=b), which Spring's Pageable expects.
export const getSourcingOrders = (page = 0, size = 10, filters = {}) =>
  api.get(BASE, { params: { page, size, ...filters }, paramsSerializer: { indexes: null } });

export const createSourcingOrder = (data) => api.post(BASE, data);

export const receiveSourcingOrderDirect = (data) => api.post(`${BASE}/receive-direct`, data);

export const updateSourcingOrder = (id, data) => api.put(`${BASE}/${id}`, data);

export const deleteSourcingOrder = (id) => api.delete(`${BASE}/${id}`);

export const updateSourcingOrderStatus = (id, status) =>
  api.patch(`${BASE}/${id}/status`, { status });
